/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-plusplus */
import clsx from 'clsx'
import React, {ReactNode, useEffect} from 'react'
import toast, {Toast} from 'react-hot-toast'

import './index.scss'

export const ToastModalClassName = 'toastModal_scroll'
const ToastModalOwnClsName = 'Toast-modal-unique'
const changeClass = (type: 'add' | 'remove') => {
  const els = document.getElementsByClassName(ToastModalClassName)
  for (let i = 0; i < els.length; i++) {
    // 对当前DOM的classList中的css样式进行增加或者删除 classList.remove() classList.add()
    els[i]?.classList[type]('disable')
  }
}
// export const changeModalClass = ()=> 'toastModal_lower'
const changeModalClass = (type: 'add' | 'remove') => {
  const taostModal = document.getElementsByClassName(ToastModalOwnClsName)
  for (let j = 0; j < taostModal.length; j++) {
    // 对当前DOM的classList中的css样式进行增加或者删除 classList.remove() classList.add()
    taostModal[j].parentElement.classList[type]('toastModal_lower')
  }
}
// hideToast暴露出去就无需把t.id传出去
export const hideToast = (toastId?: string | undefined) => {
  changeClass('remove')
  return toast.remove(toastId)
}
export const ToastModal = ({
  classNameExtra = '',
  maskAllBlack = false, // mask是否全黑不透明
  maskAutoClose = true,
  transparentMask = false,
  contentFun,
  modalStyles,
  durationTime = 0,
  onClose = () => {},
  onClickMask = () => {},
  wrapScroll = false,
}: {
  durationTime?: number
  transparentMask?: boolean
  classNameExtra?: string
  maskAutoClose?: boolean
  maskAllBlack?: boolean
  modalStyles?: any
  contentFun: ({t, hideToast}: {t: Toast; hideToast: () => void}) => any
  onClose?: () => any
  onClickMask?: () => any
  wrapScroll?: boolean // 外层是否滚动
}) => {
  if (!wrapScroll) {
    changeClass('add')
  }
  toast.custom(
    (t) => {
      const handleClose = () => {
        hideToast(t.id)
        onClose()
      }
      if (durationTime) {
        setTimeout(() => {
          handleClose()
        }, durationTime)
      }
      return (
        <div
          // , maskAllBlack && 'toastModal_maskAllBlack' , !maskAllBlack && 'toastModal_maskHalfBlack'
          className={clsx(
            'toastModal_mask',
            !transparentMask && maskAllBlack && 'toastModal_maskAllBlack',
            !transparentMask && !maskAllBlack && 'toastModal_maskHalfBlack',
            classNameExtra
          )}
          onClick={() => {
            if (maskAutoClose) {
              handleClose()
            }
            onClickMask()
          }}
        >
          <div
            className={clsx(['toastModal_content'])}
            onClick={(event) => {
              // 阻止冒泡
              // 防止向遮罩冒泡
              event.stopPropagation()
            }}
          >
            {contentFun({
              t,
              hideToast: handleClose,
            })}
          </div>
        </div>
      )
    },
    {
      className: 'ToastModal',
      icon: null,
      duration: Infinity,
      style: {
        padding: '0px',
        background: 'none',
        animation: 'none',
        ...modalStyles,
      },
    }
  )
}

// 用于分享时绘制页面的toast
export const hideToastShare = ({
  contentFun,
  onClose = () => {},
}: {
  contentFun: ({t, hideToast}: {t: Toast; hideToast: () => void}) => any
  onClose?: () => any
}) => {
  changeClass('add')
  toast.custom(
    (t) => {
      const handleClose = () => {
        hideToast(t.id)
        onClose()
      }
      return (
        <div className={clsx('toastModal_mask', 'toastModal_hide')}>
          <div
            className={clsx(['toastModal_content'])}
            onClick={(event) => {
              // 阻止冒泡
              // 防止向遮罩冒泡
              event.stopPropagation()
            }}
          >
            {contentFun({
              t,
              hideToast: handleClose,
            })}
          </div>
        </div>
      )
    },
    {
      className: 'ToastModal',
      icon: null,
      duration: Infinity,
      style: {
        padding: '0px',
        background: 'none',
        animation: 'none',
      },
    }
  )
}
